// src/components/QuickSearch/primitives/QuickSearchFooter.tsx
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import KeyboardHint from './KeyboardHint'

type IconString = '↑' | '↓' | '↵' | 'ArrowUp' | 'ArrowDown' | 'Enter' | 'Return';

interface KeyboardHintItem {
  icon?: React.ReactElement | IconString;
  label?: string;
}

interface KeyboardAction {
  hints: KeyboardHintItem[];
  description: string;
}

interface QuickSearchFooterProps {
  resultCount?: number;
  keyboardActions?: KeyboardAction[];
  showResultCount?: boolean;
}

export default function QuickSearchFooter(props: QuickSearchFooterProps): React.ReactElement {
  const {
    resultCount = 0,
    keyboardActions = [
      {
        hints: [{ icon: '↑' }, { icon: '↓' }],
        description: 'navigate',
      },
      {
        hints: [{ icon: '↵' }],
        description: 'select',
      },
    ],
    showResultCount = true,
  } = props

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1.5,
        backgroundColor: 'grey.50',
      }}
    >
      <Stack direction="row" spacing={2}>
        {keyboardActions.map((action, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {action.hints.map((hint, hintIndex) => (
              <KeyboardHint
                key={hintIndex}
                icon={hint.icon}
                label={hint.label}
              />
            ))}
            <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
              {action.description}
            </Typography>
          </Box>
        ))}
      </Stack>

      {showResultCount && (
        <Typography variant="caption" fontWeight={600} color="text.secondary">
          {resultCount} {resultCount === 1 ? 'result' : 'results'}
        </Typography>
      )}
    </Box>
  )
}
